const MuiMenu = {
  styleOverrides: {
    list: {
      minWidth: '240px'
    }
  },
  variants: [{
    props: {
      type: 'actionMenu'
    },
    style: {
      '.MuiListItem-root': {
        padding: '0'
      }
    }
  }]
};
export default MuiMenu;